import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="post-harvest--evidence-files"
// Manages dynamic list of evidence file upload slots.
// Each row contains a photo-upload controller for DirectUpload.
// Serializes all signed_ids + filename + content_type into a hidden JSON field.
export default class extends Controller {
  static targets = [
    "fileList",
    "fileTemplate",
    "evidenceFilesDataField",
    "fileCount",
  ];
  static values = { counter: { type: Number, default: 0 } };

  connect() {
    this.reindex();
    this.serialize();
  }

  addFile(event) {
    event.preventDefault();
    this.counterValue++;
    const content = this.fileTemplateTarget.innerHTML.replace(
      /NEW_ID/g,
      this.counterValue,
    );
    this.fileListTarget.insertAdjacentHTML("beforeend", content);
    this.reindex();
  }

  removeFile(event) {
    event.preventDefault();
    const row = event.target.closest("[data-evidence-row]");
    if (row) {
      row.remove();
      this.reindex();
      this.serialize();
    }
  }

  photoChanged(event) {
    const { filename, contentType } = event.detail || {};
    const row = event.target.closest("[data-evidence-row]");
    if (row && filename) {
      row.dataset.filename = filename;
      row.dataset.contentType = contentType || "";
    }
    this.serialize();
  }

  serialize() {
    const rows = this.fileListTarget.querySelectorAll("[data-evidence-row]");
    const files = [];

    rows.forEach((row) => {
      const signedId = row.querySelector(
        "[data-post-harvest--photo-upload-target='signedId']",
      )?.value;
      const filename = row.dataset.filename || "";
      const contentType = row.dataset.contentType || "";

      if (signedId) {
        files.push({
          signed_id: signedId,
          filename: filename,
          content_type: contentType,
        });
      }
    });

    this.evidenceFilesDataFieldTarget.value = JSON.stringify(files);

    if (this.hasFileCountTarget) {
      this.fileCountTarget.textContent = files.length;
    }
  }

  reindex() {
    const rows = this.fileListTarget.querySelectorAll("[data-evidence-row]");
    this.counterValue = rows.length;
  }
}
